/*
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2022-02-23 10:50:10
 * @LastEditors: hexy
 * @LastEditTime: 2022-04-29 16:03:14
 * @Description: 
 * @FilePath: \ICPSxin\src\api\internetSales\projectAssess.js
 */
import request from '@/utils/request'

export function saveOrUpdate(data) {
  return request({
    url: '/icps/system/sign/cloudSell/assess/saveOrUpdate',
    method: 'post',
    data
  })
}
export function getDetails(data) {
  return request({
    url: '/icps/system/sign/cloudSell/assess/getDetails',
    method: 'post',
    data
  })
}
export function updateAssessAudit(data) {
  return request({
    url: '/icps/system/sign/cloudSell/assess/updateAssessAudit',
    method: 'post',
    data
  })
}
export function getAssessAudit(data) {
  return request({
    url: '/icps/system/sign/cloudSell/assess/getAssessAudit',
    method: 'post',
    data
  })
}
